// extracted by mini-css-extract-plugin
export default {"Illustration":"Illustration-styles__Illustration__yzle3"};